import {
  Panel,
  PanelGroup,
  PanelResizeHandle,
  ImperativePanelGroupHandle,
} from 'react-resizable-panels'
import './IntakeQueReview.css'
import {
  CaseIdServiceIdForIntakeType,
  IntakeQueReviewProps,
  ListingTableColumn,
} from '../../utils/types'
// TODO: MIght need later
// import CaseLayout from './CaseLayout'
import FaxDetails from './FaxDetails'
import { useContext, useEffect, useRef, useState } from 'react'
import {
  BUTTONS,
  ENTITY_NAME,
  FAX_HEADER_ACTIONS,
  LAYOUT_TYPE_NAMESPACE,
  MODE_CONSTANTS,
  NAMESPACES,
  RECORD_STATE,
  WBSOCKET_TOPIC,
  WEBSOCKET_ACTIONS,
} from '../../utils/constants'
import useCustomFetchAgent from '../../hooks/useCustomFetchAgent'
import {
  EntityLayout,
  EntityLayoutResponse,
  LayoutData,
  Page,
} from '../../types/layout.types'
import {
  addParamToURL,
  addToaster,
  API_END_POINT,
  completedFaxIntakeApi,
  DataTypeStore,
  discardWebIntakeApi,
  ENTITY_MANAGER_END_POINTS,
  fetchCommunicationIdCorrespondingData,
  fetchProductListAPI,
  fetchServiceListAPI,
  fetchTypeStatusForCommunications,
  flattenEntityRelationshipTree,
  getAllLayoutApi,
  getAllLayoutRecordsBasedOnService,
  getEntityDataByEntityNameIdApiForFilter,
  GetEntityDataByNameIdFilter,
  getEntityList,
  getLayoutTree,
  getParamFromURL,
  getQueueByIdApi,
  getWorkflowByEntityNameAndRecordId,
  hideLoader,
  LayoutResponseType,
  ProgramForFaxReview,
  setSelectedQueueReducer,
  showLoader,
  updateEntityInstanceApi,
  updatePatientData,
  updateRelationshipTree,
  updateRelationshipTreeObject,
  updateWorkflowDefinition,
  updateWorkflowInstance,
  WORKFLOW_UI_IDENTIFIER,
  WorkflowDefinitionsListType,
  WorkflowInstanceTaskType,
  WorkflowInstanceType,
  WorkflowProcessType,
  fetchWorkflowDefinitionsAPI,
  getLayoutByEntityIdAndTypeApi,
  fetchDuplicateRecordsAPI,
  getEntityDataByEntityFilter,
  transformToDuplicateApiPayload,
  getAllEntitiesAgentAction,
  getEntityDataByEntityNameApiForFilter,
  updateWorkflowInstanceAdditionalKeys,
  updateRequestorConfigReducer,
  getCategoryDropdownOptions,
  updateIntakeCommunicationMap,
  resetCompleteWorkflowState,
} from '@app-store'
import SelectCase from './SelectCase'
import { useNavigate, useParams } from 'react-router-dom'
import {
  CaseIntakeIdWithWorkflowType,
  EntityDataProps,
  FaxDetailsData,
  RecordFieldsProps,
  WorkflowInstanceAPIType,
} from '../../types/intakeQueue.types'
import { WebSocketContext } from '../../context/WebSocketContext'
import {
  RootState,
  useAppDispatch,
  useAppSelector,
} from '../../utils/agent.store'
import {
  entityMap,
  fetchCaseData,
  fetchEntityIdByName,
  reverseMappingOfRequestorName,
} from '../../utils/helperFunctions'
import { QUEUE_STRINGS } from '../../utils/queueIntake.types'
import {
  Accordion,
  ACTION_ICONS_NAMESPACE,
  CustomButton,
  DropdownType,
  FIELD_VALUE_CONSTANTS,
  FormInput,
  SelectDropDown,
  StepperBV,
  StepType,
  SvgReload,
  TabInterface,
  TableActionType,
} from '@ui-kit'
import { useFocusFirstElement } from '../../hooks/useFocusFirstFocusableElement'
import { FocusTrap } from 'focus-trap-react'
import { CHECK_ATTACH_IF_CASE } from '../../constants/intakeQue.constants'
import {
  APPLICATION_PREFERENCES_STRINGS,
  CALL_INTERACTIONS,
  DUPLICATION,
  REQUESTOR_MESSAGES,
} from '../../utils/strings'
import FormRenderer from '../../components/FormRenderer'
import { ShortcutKeys } from '../../constants/form.constants'
import { generateTabIndexMap } from '../../utils/tab-indexing'
import {
  addEntityData,
  editEntityData,
  editEntityDataEmbeddedAPI,
  getEntityData,
  getEntityDataByIdEmbedded,
} from '../../apis/entityData.api'
import { TOASTER_NAMESPACE } from '../../constants/addEditPage.strings'
import { FieldValues } from 'react-hook-form'
import { TabIndexMap } from '../../types/common'
import CallInteractionContextProvider, {
  CallInteractionContext,
} from '../call-interaction/CallInteactionContext'
import { v4 as uuid } from 'uuid'
import SearchLayout from '../call-interaction/SearchLayout'
import EntityLayoutWrapper from '../call-interaction/EntityLayoutWrapper'
import EntityLayoutCasePane from '../../components/workflow/EntityLayoutTask'
import { AdvancedSearchInfo } from '../call-interaction/RequestorSearchForm'
import {
  flattenObject,
  validatePhoneNumberAndAddress,
} from '../../utils/form.utils'
import { ListingTableRow } from '../../types/listingTable.types'
import { ListingTable } from '../../components/listing-table/ListingTable'
import { DuplicationScore } from '../../components/DuplicationScore'
import { isEmpty, noop, uniqueId } from 'lodash'
import { Group } from '../../types/types'

const IntakeQueReview: React.FC<IntakeQueReviewProps> = ({ entityName }) => {
  const {
    caseEntityId,
    communicationId,
    entityid: entityId,
    layoutid,
    id,
  } = useParams()

  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const entitiesList = useAppSelector(
    (state: RootState) => state.entity.entitiesByName
  )
  const recordId = getParamFromURL('caseId')

  const { wsHelper, connectionId, sendMessage, messages, getUid } =
    useContext(WebSocketContext)

  // check for if the workflow is selected
  const [isWorkflow, setIsWorkflow] = useState<boolean>(false)
  const [isAePcStatusVisible, setIsAePcStatusVisible] = useState<boolean>(false)
  const [action, setAction] = useState<string>('review')
  const [faxDetails, setFaxDetails] = useState<FaxDetailsData | null>(null)
  const [resizePanel, setResizePanel] = useState(false)
  // const [isInitialSave, setIsInitialSave] = useState<boolean>(false)
  const panelGroupRef = useRef<ImperativePanelGroupHandle>(null)
  const [programName, setProgramName] = useState<ProgramForFaxReview>()
  const [isWsConnected] = useState(!!connectionId)
  // const [caseId, setCaseId] = useState<number>(0)
  const [intakeType, setIntakeType] = useState<string>()
  const [isFocusTrapActive, setIsFocusTrapActive] = useState(false)
  const caseIntakeLayoutIdRef = useRef<CaseIntakeIdWithWorkflowType | null>(
    null
  )

  //call-interaction states
  const [currStep, setCurrStep] = useState<number>(0)
  const [renderKey, setRenderKey] = useState<boolean>(false)
  const [selectedProgramId, setSelectedProgramId] = useState<string>()
  const [selectedProductId, setSelectedProductId] = useState<string>()
  const [selectedRequestorId, setSelectedRequestorId] = useState<number>()
  const [viewEntityRecord, setViewEntityRecord] = useState<
    DataTypeStore | undefined
  >()
  const [viewCaseRecord, setViewCaseRecord] = useState<boolean>(false)
  const [advancedFiltersData, setAdvancedFiltersData] = useState<
    AdvancedSearchInfo | undefined
  >(undefined)
  const [backToFirstPage, setBackToFirstPage] = useState<boolean>(false)
  const [productOptions, setProductOptions] = useState<DropdownType<string>[]>(
    []
  )
  const [editEntityRecord, setEditEntityRecord] = useState<
    boolean | undefined
  >()
  const [addEntityRecord, setAddEntityRecord] = useState<boolean | undefined>()
  const [entityDataLeft, setEntityDataLeft] = useState<EntityDataProps>()
  const [tabs, setTabs] = useState<TabInterface[]>([])
  const [layoutInfo, setLayoutInfo] = useState<
    {
      layout?: LayoutResponseType | null
      recordData?: FieldValues | null
    }[]
  >([])
  const [recordFieldsEntityDataPayload, setRecordFieldsEntityDataPayload] =
    useState<{
      payload: GetEntityDataByNameIdFilter
      fromSearch?: boolean
    }>()
  const [recordFieldsInfo, setRecordFieldsInfo] = useState<{
    page: number
    size: number
  } | null>(null)
  const [workflowList, setWorkflowList] = useState<
    WorkflowDefinitionsListType[]
  >([])
  const [tabOffsetFromLeftSection, setTabOffsetFromLeftSection] =
    useState<number>(0)
  const [isEditMode, setIsEditMode] = useState<Record<number, boolean>>({})
  const [selectedRecord, setSelectedRecord] = useState<string>()
  const [entityDataInner, setEntityDataInner] = useState<
    EntityDataProps | undefined
  >(entityDataLeft)
  const [modal, setModal] = useState<{
    message: string
    state: boolean
    onYesClick?: () => void
    onCancelClick?: () => void
  }>({
    message: '',
    state: false,
  })
  const [agentDetails, setAgentDetails] = useState<{
    record_status: string
    last_name: string
    email: string
    first_name: string
    id: number
  } | null>(null)
  // const [communicationData, setCommunicationData] = useState<FieldValues>({})
  // const [entityDataRight, setEntityDataRight] = useState<EntityDataProps>()
  // TODO: might need later
  // const [communicationsEntityId, setCommunicationsEntityId] = useState<number>()
  // const [commEditLayoutId, setCommEditLayoutId] = useState<number>()
  const unlockOnClose = useRef(true)
  const containerRef = useRef<HTMLDivElement | null>(null)
  useFocusFirstElement(containerRef)
  const selectedTenantId = useAppSelector(
    (state: RootState) => state.authUser.selectedClientTenant?.id
  )
  const userData = useAppSelector((state) => state?.authUser?.user)

  const mode = LAYOUT_TYPE_NAMESPACE.DEFAULT_VIEW_EDIT

  const getLayoutType = () => {
    if (mode === MODE_CONSTANTS.VIEW)
      return LAYOUT_TYPE_NAMESPACE.DEFAULT_OVERVIEW

    return LAYOUT_TYPE_NAMESPACE.DEFAULT_VIEW_EDIT
  }

  const { data: allLayouts } = useCustomFetchAgent<EntityLayoutResponse>(
    `${API_END_POINT.V3_ENTITY_MANAGER}${ENTITY_MANAGER_END_POINTS.LAYOUT}`,
    {
      params: {
        type: getLayoutType(),
        entityId: caseEntityId,
        defaultValue: true,
      },
    },
    mode
  )

  const setRequestorId = (id: number | undefined) => {
    setSelectedRequestorId(id)
  }

  const releaseLock = () => {
    if (sendMessage && unlockOnClose.current && getUid)
      sendMessage(
        JSON.stringify({
          requestContext: {
            routeKey: WEBSOCKET_ACTIONS.UNLOCK,
            userId: `${userData?.first_name ?? ''} ${
              userData?.last_name ?? ''
            }`,
            communicationId: communicationId,
            entity: WBSOCKET_TOPIC.INTAKE_QUEUE,
            'x-tenantId': selectedTenantId?.toString(),
            connectionId,
            uid: getUid(WBSOCKET_TOPIC.INTAKE_QUEUE),
          },
        })
      )
  }
  const addLock = () => {
    sendMessage &&
      getUid &&
      sendMessage(
        JSON.stringify({
          requestContext: {
            routeKey: WEBSOCKET_ACTIONS.LOCK,
            userId: `${userData?.first_name ?? ''} ${
              userData?.last_name ?? ''
            }`,
            communicationId: communicationId,
            entity: WBSOCKET_TOPIC.INTAKE_QUEUE,
            'x-tenantId': selectedTenantId?.toString(),
            connectionId,
            uid: getUid(WBSOCKET_TOPIC.INTAKE_QUEUE),
          },
        })
      )
  }

  const fetchFaxDetails = async () => {
    try {
      const payload = {
        entity_name: QUEUE_STRINGS?.COMMUNICATION_LOWERCASE,
        select: [
          'programs',
          'created_at',
          'sender_name',
          'communication_id',
          'total_pages',
          'case_id',
          'users',
          'category_communication_type',
          'document',
          'c_ae_pc_document',
        ],
        related_entities: {
          users: {
            select: ['first_name', 'last_name', 'email'],
          },
          document: {
            select: ['attachment'],
          },
          c_ae_pc_document: {
            select: ['ae_pc_status'],
          },
        },
      }
      const response = await fetchCommunicationIdCorrespondingData(
        parseInt(communicationId ?? ''),
        payload
      )
      setFaxDetails(response?.data)
      if (response?.data?.c_ae_pc_document) {
        setIsAePcStatusVisible(true)
      }
      setProgramName(response?.data?.programs ?? '')
      if (response?.data?.case_id) {
        addParamToURL('caseId', response?.data?.case_id?.toString() ?? '')
      }
    } catch (error) {
      console.error(error)
    }
  }

  const fetchWebDetails = async () => {
    const payload = {
      entity_name: QUEUE_STRINGS?.HCP_PORTAL_ENTITY_LOWERCASE,
      select: [
        'name',
        'hcp_program',
        'created_at',
        'received_from',
        'enrollment_id',
        'case_id',
        'users',
      ],
      related_entities: {
        users: {
          select: ['first_name', 'last_name', 'email'],
        },
      },
    }

    try {
      const response = await fetchCommunicationIdCorrespondingData(
        parseInt(communicationId ?? ''),
        payload
      )
      setFaxDetails(response?.data)
      setProgramName(response?.data?.hcp_program ?? '')

      if (response?.data?.case_id) {
        addParamToURL('caseId', response?.data?.case_id?.toString() ?? '')
      }
    } catch (error) {
      console.error(error)
    }
  }

  // TODO: Might be need later
  // const draftCaseCreate = async () => {
  //   const layouts = Array.isArray(allLayouts) ? allLayouts : allLayouts?.content
  //   const data = layouts
  //     ?.filter((layout) => !layout.deleted)
  //     .sort(
  //       (a, b) =>
  //         moment(b.created_at).valueOf() - moment(a.created_at).valueOf()
  //     )

  //   // if (extraFields?.isAttachFax) {
  //   //   const relatedEntityData = relationshipTree?.find(
  //   //     (item) =>
  //   //       item?.entity_id?.toString() ===
  //   //       extraFields?.communicationId?.toString()
  //   //   )
  //   //   if (!isEmpty(relatedEntityData?.data) && extraFields?.communicationId) {
  //   //     finalData = {
  //   //       ...fetchData,
  //   //       [relatedEntityData?.field_name]: { id: extraFields?.communicationId },
  //   //     }
  //   //   }
  //   // }
  //   const dataValues = {
  //     assigned_to: userId,
  //     status: 'pending',
  //     communications: [
  //       {
  //         id: communicationId ?? '',
  //         _state: 'ADDED',
  //       },
  //     ],
  //   }
  //   try {
  //     const response = data
  //       ? await addEntityData(
  //           data[0].entity_name,
  //           data[0].entity_id,
  //           data[0].id,
  //           dataValues
  //         )
  //       : null
  //     if (communicationsEntityId && commEditLayoutId) {
  //       await changeFaxStatus(
  //         QUEUE_STRINGS?.COMMUNICATIONS_LOWERCASE,
  //         parseInt(communicationId ?? ''),
  //         communicationsEntityId,
  //         commEditLayoutId,
  //         {
  //           case: {
  //             id: response?.data?.id,
  //           },
  //           status: QUEUE_STRINGS?.PROCESSING,
  //           reviewer: reviewerFullName,
  //         }
  //       )
  //     }
  //     dispatch(
  //       addToaster({
  //         message: TOASTER_NAMESPACE.ADD_SUCCESS,
  //         type: 'success',
  //         id: uuid(),
  //       })
  //     )
  //     setCaseId(parseInt(response?.data?.id))
  //     setAction('create')
  //     setIsInitialSave(false)
  //   } catch (err) {
  //     console.error(err)
  //     dispatch(
  //       addToaster({
  //         message: TOASTER_NAMESPACE.FAILED_TO_ADD_RECORD,
  //         type: 'error',
  //         id: uuid(),
  //       })
  //     )
  //   }
  // }

  const handleWorkFlowCaseCreate = (instance: WorkflowInstanceType) => {
    const recordId = instance?.case_id
    const task = instance?.tasks?.[0]
    if (
      task?.identifier?.ui_identifier ===
        WORKFLOW_UI_IDENTIFIER?.ENTITY_LAYOUT ||
      task?.identifier?.ui_identifier ===
        WORKFLOW_UI_IDENTIFIER?.CUSTOM_LAYOUT_SCREEN
    ) {
      // setCaseId(parseInt(recordId?.toString() || ''))
      addParamToURL('caseId', recordId?.toString() ?? '')
      setIsWorkflow(true)
      setAction('create')
    }
  }

  //call-interaction  handle functions

  async function handleCreateWorkflowInstance(
    process: WorkflowProcessType,
    instance: WorkflowInstanceType
  ) {
    if (instance?.case_id) {
      try {
        dispatch(showLoader())
        const data = {
          communication_cases: [
            {
              id: instance.case_id,
              record_status: 'ACTIVE',
              _state: 'ADDED',
            },
          ],
          ...(selectedProgramId
            ? {
                programs: {
                  id: Number(selectedProgramId),
                },
              }
            : {}),
        }
        await editEntityDataEmbeddedAPI(
          ENTITY_NAME.COMMUNICATION,
          communicationId ?? '',
          data,
          ['communication_cases', 'programs']
        )
      } catch (err) {
        console.log(err)
      } finally {
        dispatch(hideLoader())
      }
    }
    try {
      const response = await getEntityDataByIdEmbedded(
        process?.global_variables?.entity_name ?? '',
        Number(process?.global_variables?.entity_id),
        [
          process?.global_variables?.config?.case_status ?? '',
          process?.global_variables?.config?.case_id ?? '',
        ],
        instance.case_id ?? ''
      )
      if (response.data) {
        setTabs((prev) => {
          const newTabs = [...prev]
          const newTab = {
            label: `New Case - ${response.data?.case_key}`,
            key: response.data?.case_key,
            component: (
              <EntityLayoutWrapper
                key={response.data?.case_key}
                caseId={instance.case_id}
                definition={process}
                instance={instance}
                workflowIndex={prev.length}
                updateLabel={(workflowIndex?: number) => {
                  if (workflowIndex !== undefined) {
                    handleSetTabs(workflowIndex)
                  }
                }}
              />
            ),
          }
          // setDefaultActiveTab(newTab)
          newTabs.push(newTab)
          return newTabs
        })
        setLayoutInfo((prev) => {
          prev.push({
            layout: undefined,
            recordData: undefined,
          })
          return prev
        })
      }
    } catch (err) {
      console.error(err)
    }
  }
  const fetchWorkFlowInstance = async () => {
    try {
      if (selectedProgramId && selectedProductId) {
        let serviceIds: Set<number> | undefined = undefined
        const allowedServices = await fetchServiceListAPI(
          selectedProgramId,
          selectedProductId
        )
        if (allowedServices?.data) {
          serviceIds = new Set(
            allowedServices.data.map((service: { id: number }) => service.id)
          )
        }
        const searchCriteria = [
          {
            search_key: 'PROGRAM_ID',
            search_value: [selectedProgramId],
            operator: 'EQUALS',
          },
          {
            search_key: 'SERVICE_ID',
            search_value: Array.from(serviceIds ?? []).map(String),
            operator: 'EQUALS',
          },
          {
            search_key: 'INDEPENDENT',
            search_value: ['true'],
            operator: 'EQUALS',
          },
          {
            search_key: 'RECORD_STATUS',
            search_value: ['ACTIVE'],
            operator: 'EQUALS',
          },
        ]
        const response = await fetchWorkflowDefinitionsAPI(searchCriteria)
        if (response?.data) {
          setWorkflowList(
            response.data.content.filter(
              (item: WorkflowDefinitionsListType) =>
                !item.name
                  ?.toLowerCase()
                  .includes(NAMESPACES.DO_NOT_USE?.toLowerCase())
            )
          )
        }
      }
    } catch (err) {
      console.log(err)
    }
  }

  const handleSetTabs = (workflowIndex: number) => {
    setTabs((prev) => {
      const updatedTabs = [...prev]
      updatedTabs[workflowIndex].label = updatedTabs[
        workflowIndex
      ].label.replace('New Case - ', '')
      return updatedTabs
    })
  }

  const handleIsEditMode = (value: Record<number, boolean>) => {
    setIsEditMode(value)
  }
  const handleModal = (value: {
    message: string
    state: boolean
    onYesClick?: () => void
    onCancelClick?: () => void
  }) => {
    setModal(value)
  }
  const updateProductRequestor = async () => {
    try {
      if (entityName === QUEUE_STRINGS?.HCP_PORTAL_ENTITY_LOWERCASE) {
        await editEntityDataEmbeddedAPI(
          entityName ?? '',
          communicationId ?? '',
          {
            product: {
              id: Number(selectedProductId),
            },
            requestor: {
              id: Number(selectedRequestorId),
            },
          },
          ['products', 'requestor']
        )
      } else {
        await editEntityDataEmbeddedAPI(
          entityName ?? '',
          communicationId ?? '',
          {
            products: {
              id: Number(selectedProductId),
              _state: RECORD_STATE.CHANGED,
            },
            requestor: {
              id: Number(selectedRequestorId),
              _state: RECORD_STATE.CHANGED,
            },
          },
          ['products', 'requestor']
        )
      }
    } catch (err) {
      console.error(err)
    }
  }
  const handleNext = () => {
    updateProductRequestor()
    setCurrStep((prev) => prev + 1)
  }
  const handleBack = () => {
    if (currStep === 1) {
      setViewEntityRecord(undefined)
      setAddEntityRecord(false)
      setEditEntityRecord(false)
      setBackToFirstPage(true)
    }
    setCurrStep((prev) => prev - 1)
  }
  const handleProductChange = (e: DropdownType<unknown, string>) => {
    setSelectedProductId(e?.value)
  }
  const handleProgramChange = (e: DropdownType<unknown, string>) => {
    setSelectedProgramId(e?.value)
  }

  const getClassName = (viewEntityRecord: DataTypeStore | undefined) => {
    return viewEntityRecord || addEntityRecord ? 'hidden' : 'visible'
  }

  const getClassNameForViewEntitySection = (
    viewEntityRecord: DataTypeStore | undefined,
    addEntityRecord: boolean | undefined
  ) => {
    return viewEntityRecord || addEntityRecord ? 'visible' : 'hidden'
  }

  const fetchProducts = async (id: number) => {
    try {
      dispatch(showLoader())
      const response = await fetchProductListAPI(id)
      const products: DropdownType<string>[] = []
      response?.data?.forEach(
        (element: { id: number; trademarked_name: string }) => {
          products.push({
            label: element.trademarked_name,
            value: element.id?.toString(),
          })
        }
      )
      setProductOptions(products)
    } catch (error) {
      console.log('errors', error)
    } finally {
      dispatch(hideLoader())
    }
  }

  const fetchCommunications = async () => {
    try {
      dispatch(showLoader())
      const response = await getEntityDataByEntityNameIdApiForFilter(
        {
          payload: {
            entity_name: entityName ?? '',
            page: 0,
            size: 1,
            select:
              entityName === QUEUE_STRINGS?.HCP_PORTAL_ENTITY_LOWERCASE
                ? [
                    'name',
                    'hcp_program',
                    'created_at',
                    'received_from',
                    'enrollment_id',
                    'case_id',
                    'users',
                  ]
                : [
                    'communication_id',
                    'users',
                    'created_at',
                    'cases',
                    'communication_cases',
                    'programs',
                    'sender_name',
                  ],
            related_entities: {
              users: {
                select: ['first_name', 'last_name', 'email'],
              },
            },
          },
        },
        communicationId ?? ''
      )
      if (response?.data?.users) {
        setAgentDetails(response?.data?.users)
      }
      const programsId =
        response?.data?.[
          entityName === QUEUE_STRINGS?.HCP_PORTAL_ENTITY_LOWERCASE
            ? 'hcp_program'
            : 'programs'
        ]?.id
      if (programsId) setSelectedProgramId(programsId?.toString())
      if (response.data?.communication_cases?.length) {
        try {
          addParamToURL(
            'caseId',
            response?.data?.communication_cases
              ?.find(
                (c: { record_status: string }) => c.record_status === 'ACTIVE'
              )
              ?.id?.toString() ?? ''
          )
          const newTabs = []
          const newEditMode: Record<number, boolean> = {}
          for (let i = 0; i < response.data.communication_cases.length; i++) {
            const comm_case = response.data.communication_cases[i]
            const resp = await getWorkflowByEntityNameAndRecordId({
              entityName: 'case',
              recordId: comm_case.id,
            })
            const case_data = await getEntityDataByEntityNameIdApiForFilter(
              {
                payload: {
                  entity_name:
                    (resp.data as unknown as WorkflowInstanceAPIType).process
                      ?.global_variables?.entity_name ?? '',
                  page: 0,
                  size: 100,
                  select: [
                    (resp.data as unknown as WorkflowInstanceAPIType).process
                      ?.global_variables?.config?.case_status ?? '',
                    (resp.data as unknown as WorkflowInstanceAPIType).process
                      ?.global_variables?.config?.case_id ?? '',
                    'requestor',
                  ],
                  related_entities: {
                    requestor: {
                      select: ['entity_type', 'record_id', 'record_key'],
                    },
                  },
                },
              },
              comm_case.id
            )
            if (i === 0 && case_data.data?.requestor) {
              const requestorIsPerson = PERSON_TYPE_ENTITIES.find(
                (option) =>
                  option.label === case_data.data?.requestor?.entity_type
              )
              setEntityDataLeftValue(requestorIsPerson, case_data)
              setViewEntityRecord({
                ...case_data.data.requestor,
                id: case_data.data.requestor?.record_id,
                requestor_id: case_data.data.requestor?.id,
              })
            }
            newTabs.push({
              label: `${case_data.data?.case_key}`,
              key: case_data.data?.case_key,
              component: (
                <EntityLayoutWrapper
                  key={case_data.data?.case_key}
                  caseId={comm_case.id}
                  definition={
                    (resp.data as unknown as WorkflowInstanceAPIType).process
                  }
                  instance={
                    (resp.data as unknown as WorkflowInstanceAPIType)
                      .workflow_instance
                  }
                  workflowIndex={newTabs.length}
                  updateLabel={(workflowIndex?: number) => {
                    if (workflowIndex !== undefined) {
                      setTabs((prev) => {
                        const updatedTabs = [...prev]
                        updatedTabs[workflowIndex].label = updatedTabs[
                          workflowIndex
                        ].label.replace('New Case - ', '')
                        return updatedTabs
                      })
                    }
                  }}
                />
              ),
            })
            setLayoutInfo((prev) => {
              prev.push({
                layout: undefined,
                recordData: undefined,
              })
              return prev
            })
            newEditMode[newTabs.length - 1] = false
          }
          setTabs(newTabs)
        } catch (error) {
          console.log(error)
        }
      }
    } catch (error) {
      console.log(error)
    } finally {
      dispatch(hideLoader())
    }
  }

  const setEntityDataLeftValue = (
    requestorIsPerson:
      | {
          label: string
          value: string
        }
      | undefined,
    case_data: {
      data:
        | {
            requestor?: {
              entity_type?: string
            }
          }
        | undefined
    }
  ) => {
    if (requestorIsPerson) {
      setEntityDataLeft({
        label: case_data.data?.requestor?.entity_type ?? '',
        value: requestorIsPerson?.value ?? '',
      })
    } else {
      setEntityDataLeft(ORGANIZATION_ENTITY)
    }
  }

  const fetchRelationshipTree = async ({ entityId }: { entityId: string }) => {
    try {
      const response = await getLayoutTree(
        entityId || '',
        FIELD_VALUE_CONSTANTS?.ONE?.toString()
      )
      if (response?.data) {
        dispatch(
          updateRelationshipTree(flattenEntityRelationshipTree(response?.data))
        )
        dispatch(
          updateRelationshipTreeObject({
            [response?.data?.entity_name ?? '']: { ...response?.data },
          })
        )
      }
    } catch (error) {
      console.log(error)
    }
  }

  const updateStatusToCompleted = async () => {
    if (intakeType === NAMESPACES.FAX_UPPERCASE) {
      const response = await fetchTypeStatusForCommunications(
        NAMESPACES.COMMUNICATION_STATUS_LOWERCASE
      )
      const faxEnrollmentStatusId = response?.data?.find(
        (item: { value: string }) =>
          item?.value?.toLowerCase() === NAMESPACES.COMPLETED_LOWERCASE
      )?.id
      if (faxEnrollmentStatusId) {
        await completedFaxIntakeApi(
          parseInt(communicationId ?? ''),
          parseInt(entityId ?? ''),
          parseInt(layoutid ?? ''),
          {
            category_status: {
              id: faxEnrollmentStatusId,
              _state: RECORD_STATE.CHANGED,
            },
            reason: '',
          }
        )
      }
    } else {
      const response = await fetchTypeStatusForCommunications(
        NAMESPACES.WEB_ENROLLMENT_STATUS
      )
      const webEnrollmentStatusId = response?.data?.find(
        (item: { value: string }) =>
          item?.value?.toLowerCase() === NAMESPACES.COMPLETED_LOWERCASE
      )?.id
      if (webEnrollmentStatusId) {
        await discardWebIntakeApi(
          parseInt(communicationId ?? ''),
          parseInt(entityId ?? ''),
          parseInt(layoutid ?? ''),
          {
            enrollment_status: {
              id: webEnrollmentStatusId,
              _state: RECORD_STATE.CHANGED,
            },
            reason: '',
          }
        )
      }
    }
  }
  const updateStatusToProcessing = async (id?: number) => {
    if (intakeType === NAMESPACES.FAX_UPPERCASE) {
      const response = await fetchTypeStatusForCommunications(
        NAMESPACES.COMMUNICATION_STATUS_LOWERCASE
      )
      const faxEnrollmentStatusId = response?.data?.find(
        (item: { value: string }) =>
          item?.value?.toLowerCase() === NAMESPACES.PROCESSING_LOWERCASE
      )?.id
      if (faxEnrollmentStatusId) {
        await completedFaxIntakeApi(
          parseInt(communicationId ?? ''),
          parseInt(entityId ?? ''),
          parseInt(layoutid ?? ''),
          {
            category_status: {
              id: faxEnrollmentStatusId,
              _state: RECORD_STATE.CHANGED,
            },
            cases: id
              ? {
                  id: id,
                  _state: RECORD_STATE.CHANGED,
                }
              : undefined,
            reason: '',
          }
        )
      }
    } else {
      const response = await fetchTypeStatusForCommunications(
        NAMESPACES.WEB_ENROLLMENT_STATUS
      )
      const webEnrollmentStatusId = response?.data?.find(
        (item: { value: string }) =>
          item?.value?.toLowerCase() === NAMESPACES.PROCESSING_LOWERCASE
      )?.id
      if (webEnrollmentStatusId) {
        await discardWebIntakeApi(
          parseInt(communicationId ?? ''),
          parseInt(entityId ?? ''),
          parseInt(layoutid ?? ''),
          {
            enrollment_status: {
              id: webEnrollmentStatusId,
              _state: RECORD_STATE.CHANGED,
            },
            // case_id: id,
            reason: '',
          }
        )
      }
    }
  }

  // Function to add the current que name in breadcrumb
  const setBreadCrumb = async (id: string) => {
    try {
      const response = await getQueueByIdApi(parseFloat(id))
      if (response) {
        dispatch(setSelectedQueueReducer(response?.data?.name))
      }
    } catch (error) {
      console.error(error)
    }
  }

  const handleShowIntakeLayoutForChildCase = async (
    selectedCaseService: CaseIdServiceIdForIntakeType
  ) => {
    try {
      dispatch(showLoader())
      if (selectedCaseService?.caseId && selectedCaseService?.serviceId) {
        const response = await getAllLayoutRecordsBasedOnService(
          selectedCaseService.serviceId
        )

        const layoutData = response?.data
        const intakeLayoutId =
          layoutData?.caseTypeLayoutsPage?.intake_layout_id?.id
        const defaultEditLayoutId = layoutData?.defaultLayouts?.find(
          (layout: { type: string; id: number }) =>
            layout.type === LAYOUT_TYPE_NAMESPACE.VIEW_EDIT
        )?.id

        const finalLayoutId = intakeLayoutId ?? defaultEditLayoutId

        await updateEntityInstanceApi(
          ENTITY_NAME?.CASE_LOWER,
          parseInt(selectedCaseService?.caseId),
          parseInt(caseEntityId ?? ''),
          finalLayoutId,
          {
            request_received_at: faxDetails?.created_at,
          }
        )
        if (finalLayoutId) {
          const newValue = {
            intakeId: finalLayoutId,
            caseEntityId: caseEntityId ?? '',
            selectedWorkFlow: selectedCaseService.workFlowInstance,
          }
          caseIntakeLayoutIdRef.current = newValue
        }

        addParamToURL('caseId', selectedCaseService.caseId)
        setIsWorkflow(true)
        setAction('create')
      }
    } catch (error) {
      console.error(error)
    } finally {
      dispatch(hideLoader())
    }
  }

  const fetchWorkflowData = async (payload: {
    recordId: string
    entityName: string
  }) => {
    dispatch(showLoader())
    try {
      const response = await getWorkflowByEntityNameAndRecordId(payload)
      const data = response?.data
      if (!data) return
      setIsWorkflow(true)
      const { workflow_instance, process, ...rest } = data
      const serviceId = process?.service_id

      let updatedInstance = workflow_instance
      if (serviceId) {
        try {
          const layoutRecords = await getAllLayoutRecordsBasedOnService(
            serviceId
          )
          const layoutData = layoutRecords?.data

          const intakeLayoutId =
            layoutData?.caseTypeLayoutsPage?.intake_layout_id?.id

          const defaultEditLayoutId = layoutData?.defaultLayouts?.find(
            (layout: { name: string; id: number; type: string }) =>
              layout.type === LAYOUT_TYPE_NAMESPACE.VIEW_EDIT
          )?.id

          const layoutIdToUse = intakeLayoutId ?? defaultEditLayoutId

          if (layoutIdToUse) {
            const updatedTasks = workflow_instance?.tasks?.map(
              (task: WorkflowInstanceTaskType, index: number) =>
                index === 0
                  ? {
                      ...task,
                      identifier: {
                        ...task.identifier,
                        entity_id: caseEntityId,
                        entity_name: ENTITY_NAME.CASE,
                        layout_info: {
                          ...task.identifier?.layout_info,
                          layout_id: layoutIdToUse,
                          layout_type: LAYOUT_TYPE_NAMESPACE.VIEW_EDIT_TYPE,
                        },
                      },
                    }
                  : task
            )

            updatedInstance = {
              ...workflow_instance,
              tasks: updatedTasks,
            }
          }
        } catch (layoutErr) {
          console.error(layoutErr)
        }
      }

      dispatch(updateWorkflowInstance(updatedInstance))
      dispatch(updateWorkflowDefinition(process))
      dispatch(updateWorkflowInstanceAdditionalKeys({ ...rest }))
    } catch (err) {
      console.error(err)
      navigate(-1)
    } finally {
      dispatch(hideLoader())
    }
  }

  const showIntakeLayout = async (caseId: string) => {
    if (!caseId) return
    fetchCaseData(caseId, dispatch)
    try {
      setAction('create')
      const hasWorkflowInfo =
        caseIntakeLayoutIdRef?.current?.caseEntityId &&
        caseIntakeLayoutIdRef?.current?.intakeId

      if (hasWorkflowInfo) {
        setIsWorkflow(true)

        const selectedWorkflow =
          caseIntakeLayoutIdRef?.current?.selectedWorkFlow
        const workflowInstance = selectedWorkflow?.workflow_instance
        const process = selectedWorkflow?.process

        const updatedTasks = workflowInstance?.tasks?.map((task, index) => {
          if (index === 0) {
            return {
              ...task,
              identifier: {
                ...task.identifier,
                entity_id: caseIntakeLayoutIdRef?.current?.caseEntityId,
                entity_name: ENTITY_NAME.CASE,
                layout_info: {
                  ...task.identifier?.layout_info,
                  layout_id: caseIntakeLayoutIdRef?.current?.intakeId,
                  layout_type: LAYOUT_TYPE_NAMESPACE.VIEW_EDIT_TYPE,
                },
              },
            }
          }
          return task
        })

        dispatch(
          updateWorkflowInstance({ ...workflowInstance, tasks: updatedTasks })
        )
        dispatch(updateWorkflowDefinition(process))
      } else {
        await fetchWorkflowData({ recordId: caseId, entityName: 'case' })
      }
    } catch (error) {
      console.error('Error in showIntakeLayout:', error)
    }
  }

  const fetchRequestorProduct = async () => {
    try {
      const res = await getEntityDataByIdEmbedded(
        entityName ?? '',
        Number(entityId),
        entityName === QUEUE_STRINGS.HCP_PORTAL_ENTITY_LOWERCASE
          ? ['product', 'requestor']
          : ['products', 'requestor'],
        communicationId ?? ''
      )
      if (res?.data) {
        if (entityName === QUEUE_STRINGS.HCP_PORTAL_ENTITY_LOWERCASE) {
          setSelectedProductId(res?.data?.product?.id.toString() || '')
        } else {
          setSelectedProductId(res?.data?.products?.id.toString() || '')
        }
        setSelectedRequestorId(res?.data?.requestor?.id.toString())
        if (res?.data.requestor) {
          setViewEntityRecord({
            ...res?.data.requestor,
            id: res?.data.requestor?.record_id,
            requestor_id: res?.data?.requestor?.id,
          })
          const requestorIsPerson = PERSON_TYPE_ENTITIES.find(
            (option) =>
              option.label === entityMap?.[res?.data?.requestor?.entity_type]
          )
          if (requestorIsPerson) {
            setCurrStep((prev) => prev + 2)
            setEntityDataLeft(requestorIsPerson)
          }
        }
      }
    } catch (err) {
      console.error(err)
    }
  }

  const getIntakeCommunicationMapping = async () => {
    const communicationTypes = await getCategoryDropdownOptions(
      'communication_type',
      ['name', 'value', 'label']
    )
    const intakeTypes = await getCategoryDropdownOptions('Intake Channel', [
      'name',
      'value',
      'label',
    ])
    const intakeCommunicationMap: Record<string, string> = {}
    communicationTypes.data.forEach(
      (comm: (typeof communicationTypes.data)[0]) => {
        const intake = intakeTypes.data.find(
          (int: (typeof intakeTypes.data)[0]) =>
            int.value.toLowerCase().startsWith(comm.label.toLowerCase())
        )
        if (intake) {
          intakeCommunicationMap[comm.id] = intake.id
        }
      }
    )
    dispatch(updateIntakeCommunicationMap(intakeCommunicationMap))
  }

  useEffect(() => {
    const fetchCommunicationDetails = async () => {
      if (entityName === QUEUE_STRINGS?.HCP_PORTAL_ENTITY_LOWERCASE) {
        await fetchWebDetails()
        setIntakeType(QUEUE_STRINGS.WEB)
      } else {
        await fetchFaxDetails()
        setIntakeType(QUEUE_STRINGS.FAX)
      }
    }
    fetchCommunicationDetails()
    fetchRequestorProduct()
  }, [communicationId])

  useEffect(() => {
    const fetchCommunicationsEntityIds = async () => {
      const caseEntityData =
        intakeType === QUEUE_STRINGS?.FAX
          ? await fetchEntityIdByName(
              dispatch,
              QUEUE_STRINGS?.COMMUNICATIONS_LOWERCASE
            )
          : null

      if (caseEntityData?.id) {
        // TODO: MIght need later
        // await setCommunicationsEntityId(caseEntityData.id)
        // const response = await fetchLayoutIdByEntityId(
        //   dispatch,
        //   caseEntityData.id,
        //   QUEUE_STRINGS?.EDIT_MODE
        // )
        // await setCommEditLayoutId(response[0]?.id)
      }
    }
    if (caseEntityId) {
      fetchRelationshipTree({ entityId: caseEntityId })
    }
    fetchCommunicationsEntityIds()
  }, [dispatch, caseEntityId])

  useEffect(() => {
    const data =
      JSON.parse(sessionStorage.getItem(CHECK_ATTACH_IF_CASE) ?? 'null') ?? null
    if (recordId && (!data || data?.id !== recordId)) {
      showIntakeLayout(recordId)
    }
    if (id) {
      setBreadCrumb(id)
    }
    if (recordId) {
      setCurrStep(2)
    }
  }, [recordId])

  useEffect(() => {
    // TODO: might need later
    // fetchFaxDetails()
    if (wsHelper && isWsConnected) {
      addLock()
      return releaseLock
    } else if (wsHelper && sendMessage && !isWsConnected && getUid) {
      setTimeout(() => {
        sendMessage(
          JSON.stringify({
            requestContext: {
              routeKey: WEBSOCKET_ACTIONS.SUBSCRIBE,
              userId: `${userData?.first_name ?? ''} ${
                userData?.last_name ?? ''
              }`,
              communicationId: '',
              entity: WBSOCKET_TOPIC.INTAKE_QUEUE,
              'x-tenantId': selectedTenantId?.toString(),
              connectionId,
              uid: getUid(WBSOCKET_TOPIC.INTAKE_QUEUE),
            },
          })
        )
      }, 100)
    }
  }, [connectionId])

  useEffect(() => {
    if (
      messages?.connected_users &&
      messages?.entity === WBSOCKET_TOPIC.INTAKE_QUEUE &&
      Array.isArray(messages?.connected_users) &&
      !isWsConnected
    ) {
      const lockedUser = messages?.connected_users.find(
        (user: string | number | DataTypeStore) =>
          typeof user === 'object' &&
          user?.action === WEBSOCKET_ACTIONS.LOCK &&
          user?.communication_id === communicationId &&
          user?.tenant_id === selectedTenantId?.toString()
      )
      if (lockedUser) {
        navigate('../')
      } else {
        addLock()
        return releaseLock
      }
    }
  }, [messages])

  useEffect(() => {
    if (panelGroupRef.current) {
      panelGroupRef.current?.setLayout([0.4, 0.6])
    }
  }, [resizePanel])

  //call-interaction effect
  useEffect(() => {
    if (programName?.id !== undefined) {
      fetchProducts(programName.id)
    }
  }, [programName])

  useEffect(() => {
    fetchCommunications()
    getIntakeCommunicationMapping()
  }, [selectedTenantId])

  useEffect(() => {
    if (selectedProgramId) fetchProducts(Number(selectedProgramId))
  }, [selectedProgramId])

  useEffect(() => {
    if (!viewEntityRecord) {
      setTabOffsetFromLeftSection(0)
    }
  }, [viewEntityRecord])

  useEffect(() => {
    fetchRelationshipTree({
      entityId: '32',
    })
    if (window.location.href.includes('/case')) {
      navigate(window.location.pathname.split('/case')[0], { replace: true })
    }
    return () => {
      dispatch(resetCompleteWorkflowState())
    }
  }, [])

  useEffect(() => {
    if (selectedProductId && selectedProgramId) fetchWorkFlowInstance()
  }, [selectedProductId, selectedProductId])

  let content: JSX.Element

  const isStep2AndWorkflowCreating =
    currStep === 2 && isWorkflow && action === FAX_HEADER_ACTIONS.CREATE

  if (isStep2AndWorkflowCreating || faxDetails?.case_id) {
    content = (
      <div className="max-h-screen pt-4 pr-[0.5rem] border border-1 intakeQueReview">
        <EntityLayoutCasePane
          updateStatusToCompleted={updateStatusToCompleted}
          updateStatusToProcessing={updateStatusToProcessing}
          faxDetails={faxDetails}
          intakeEntityName={entityName}
        />
      </div>
    )
  } else {
    content = (
      <div className="width-full flex flex-col gap-4 p-3 -mt-8">
        <SelectCase
          viewEntityRecord={viewEntityRecord}
          intakeType={intakeType ?? ''}
          programName={programName}
          programId={selectedProgramId ?? ''}
          productId={selectedProductId ?? ''}
          requestorId={selectedRequestorId}
          // TODO: require later
          // unlockOnCreateCase={unlockOnClose}
          // setIsInitialSave={setIsInitialSave}
          // draftCaseCreate={draftCaseCreate}
          unlockOnAttach={unlockOnClose}
          handleWorkFlowCaseCreate={handleWorkFlowCaseCreate}
          key={communicationId}
          entityName={entityName}
          faxDetails={faxDetails}
          updateStatusToCompleted={updateStatusToCompleted}
          handleShowIntakeLayoutForChildCase={
            handleShowIntakeLayoutForChildCase
          }
          updateStatusToProcessing={updateStatusToProcessing}
          setEditEntityRecord={setEditEntityRecord}
          setViewCaseRecord={setViewCaseRecord}
          viewCaseRecord={viewCaseRecord}
        />
      </div>
    )
  }

  useEffect(() => {
    const requiredViewEntities: string[] = [
      ENTITY_NAME.PROVIDER_VIEW_KEY,
      ENTITY_NAME.PATIENT_ENROLLMENT_VIEW_KEY,
      ENTITY_NAME.CASE_VIEW_KEY,
      ENTITY_NAME.PHARMACY_VIEW_KEY,
      ENTITY_NAME.FACILITIES_VIEW_KEY,
    ]

    const allEntities = Object.values(entitiesList)
    const viewEntities = allEntities.filter((entity) =>
      requiredViewEntities.includes(entity.name)
    )

    if (viewEntities.length < requiredViewEntities.length) {
      dispatch(getAllEntitiesAgentAction())
    }
  }, [])

  return (
    <CallInteractionContextProvider
      isEditMode={isEditMode}
      handleIsEditMode={handleIsEditMode}
      modal={modal}
      handleModal={handleModal}
      tabs={tabs}
      setTabs={setTabs}
      viewEntityRecord={viewEntityRecord}
      workflowList={workflowList}
      tabIndexOffset={tabOffsetFromLeftSection}
      setTabOffset={setTabOffsetFromLeftSection}
      layoutInfo={layoutInfo}
      setLayoutInfo={setLayoutInfo}
    >
      <FocusTrap
        active={isFocusTrapActive}
        focusTrapOptions={{
          allowOutsideClick: true,
          escapeDeactivates: true,
          setReturnFocus: false,
          clickOutsideDeactivates: true,
          initialFocus: false,
          onDeactivate: () => {
            setIsFocusTrapActive(false)
          },
        }}
      >
        <div
          ref={containerRef}
          onFocus={() => {
            setIsFocusTrapActive(true)
          }}
        >
          <PanelGroup
            className="resize-panel-group intake-review flex flex-col w-full h-full"
            autoSaveId="example"
            direction="horizontal"
            ref={panelGroupRef}
          >
            <div className="flex flex-row min-h-[79vh] h-full w-full">
              {/* Left Section: Form Preview */}
              <Panel
                className="relative overflow-y-auto max-h-screen"
                defaultSize={50}
                minSize={27}
              >
                <div className="flex flex-col h-full w-full">
                  {/* May be used later */}
                  {/* <div
                    className={`text-[1.25rem] font-primary text-accent-900 leading-[1.5rem] text-left ${
                      isWorkflow ? 'mb-[1.45rem]' : 'mb-[0.5rem]'
                    }`}
                  >
                    {intakeType &&
                      (() => {
                        if (intakeType === QUEUE_STRINGS.FAX) {
                          return QUEUE_STRINGS.FAX_REVIEW
                        } else if (intakeType === QUEUE_STRINGS.WEB) {
                          return QUEUE_STRINGS.WEB_INTAKE_REVIEW
                        } else {
                          return QUEUE_STRINGS.EMAIL_REVIEW
                        }
                      })()}
                  </div> */}
                  <FaxDetails
                    intakeType={intakeType ?? ''}
                    unlockOnDiscard={unlockOnClose}
                    faxDetails={faxDetails}
                    setPanelSize={setResizePanel}
                    key={communicationId}
                    allLayouts={allLayouts}
                    isWorkflow={isWorkflow}
                    agentDetails={agentDetails}
                    isAePcStatusVisible={isAePcStatusVisible}
                  />
                </div>
              </Panel>
              <PanelResizeHandle />

              {faxDetails?.case_id ? (
                <>
                  {' '}
                  <Panel
                    className="relative overflow-y-auto max-h-screen"
                    defaultSize={60}
                  >
                    {/* Right Section: Case Layout */}

                    {action === FAX_HEADER_ACTIONS.CREATE ? (
                      <div className="scrollbar-hidden max-h-screen pt-4 pr-[0.5rem] border border-1 intakeQueReview">
                        {
                          isWorkflow ? (
                            <EntityLayoutCasePane
                              updateStatusToCompleted={updateStatusToCompleted}
                              updateStatusToProcessing={
                                updateStatusToProcessing
                              }
                              faxDetails={faxDetails}
                              intakeEntityName={entityName}
                            />
                          ) : (
                            <></>
                          ) // TODO: MIght need later
                          // <CaseLayout
                          //   action={action}
                          //   setAction={setAction}
                          //   intakeType={intakeType ?? ''}
                          //   isInitialSave={isInitialSave}
                          //   caseId={caseId}
                          //   allLayouts={allLayouts}
                          //   loading={loading}
                          //   setIsInitialSave={setIsInitialSave}
                          //   key={communicationId}
                          //   faxDetails={faxDetails}
                          // />
                        }
                      </div>
                    ) : (
                      <SelectCase
                        viewEntityRecord={viewEntityRecord}
                        intakeType={intakeType ?? ''}
                        programName={programName}
                        unlockOnAttach={unlockOnClose}
                        programId={selectedProgramId ?? ''}
                        productId={selectedProductId ?? ''}
                        requestorId={selectedRequestorId}
                        // TODO: require later
                        // unlockOnCreateCase={unlockOnClose}
                        // setIsInitialSave={setIsInitialSave}
                        // draftCaseCreate={draftCaseCreate}
                        handleWorkFlowCaseCreate={handleWorkFlowCaseCreate}
                        key={communicationId}
                        entityName={entityName}
                        faxDetails={faxDetails}
                        updateStatusToCompleted={updateStatusToCompleted}
                        handleShowIntakeLayoutForChildCase={
                          handleShowIntakeLayoutForChildCase
                        }
                        updateStatusToProcessing={updateStatusToProcessing}
                      />
                    )}
                    {/* else show Case Listing */}
                  </Panel>
                </>
              ) : (
                <Panel
                  key={renderKey.toString()}
                  className="relative"
                  defaultSize={60}
                  minSize={25}
                >
                  <div
                    className={`flex flex-col gap-2 ${
                      currStep === 2 && isWorkflow
                        ? 'max-h-screen'
                        : 'border border-1 p-3 scrollbar-hidden'
                    }  border-accent-100 w-full h-full`}
                  >
                    {currStep === 2 && isWorkflow ? (
                      <></>
                    ) : (
                      <div className="p-2 w-full ">
                        <div className="flex justify-between items-center overflow-x-auto gap-2 scrollbar-hidden">
                          <div
                            className={currStep < 1 ? 'invisible' : undefined}
                          >
                            <CustomButton
                              isFilled={false}
                              dataQaId="add-section-btn"
                              color="primary"
                              className="text-xs"
                              widthClass="w-[4.5rem] h-8"
                              onClick={handleBack}
                            >
                              <span>Back</span>
                            </CustomButton>
                          </div>
                          <div className="bg-secondary-25 w-full">
                            <StepperBV
                              steps={steps}
                              currentStep={currStep}
                              fontSize="text-xs"
                            />
                          </div>

                          <div
                            className={currStep > 2 ? 'invisible' : undefined}
                          >
                            <CustomButton
                              isFilled={true}
                              dataQaId="add-section-btn"
                              color="primary"
                              className="text-xs"
                              widthClass="w-[4.5rem] h-8"
                              onClick={handleNext}
                              disabled={
                                currStep === 0 ||
                                currStep === 2 ||
                                addEntityRecord ||
                                editEntityRecord
                              }
                            >
                              <span>Next</span>
                            </CustomButton>
                          </div>
                        </div>
                        <div className="grid grid-cols-3 gap-x-4 w-full mt-[1.5rem]">
                          <FormInput
                            name={`channel`}
                            label={'Channel'}
                            type="text"
                            required={true}
                            value={
                              faxDetails?.category_communication_type?.label ===
                              QUEUE_STRINGS.MAIL
                                ? QUEUE_STRINGS.EMAIL
                                : intakeType
                            }
                            disabled={true}
                          />
                          <SelectDropDown
                            label={CALL_INTERACTIONS.PROGRAM}
                            options={[
                              {
                                label:
                                  programName?.operational_program_name ?? '',
                                value: '1',
                              },
                            ]}
                            name="program-name"
                            onChange={handleProgramChange}
                            dataQaId="program"
                            className="bg-white"
                            defaultValue="1"
                            required={true}
                            disabled={true}
                          />
                          <SelectDropDown
                            label={CALL_INTERACTIONS.PRODUCT}
                            options={productOptions}
                            name=""
                            onChange={handleProductChange}
                            dataQaId="product"
                            className="bg-white"
                            defaultValue={selectedProductId ?? ''}
                            required={true}
                            disabled={currStep === 1 || currStep === 2}
                          />
                        </div>
                      </div>
                    )}

                    <div
                      className={`flex w-full ${
                        isWorkflow ? 'h-full' : ''
                      } overflow-y-auto
                      right-col-wrap flex-1 min-h-0`}
                    >
                      <div
                        className={`flex flex-col w-full border-[#C8C8C8] rounded-md h-full`}
                      >
                        {currStep === 0 || currStep === 1 ? (
                          <div className="overflow-y-auto px-2 h-full">
                            {(viewEntityRecord || addEntityRecord) &&
                            entityDataLeft ? (
                              <div
                                className={getClassNameForViewEntitySection(
                                  viewEntityRecord,
                                  addEntityRecord
                                )}
                              >
                                <ViewEntitySection
                                  setBackToFirstPage={setBackToFirstPage}
                                  label={
                                    PERSON_TYPE_ENTITIES.find(
                                      (entity) =>
                                        entity.label === entityDataLeft.label
                                    )
                                      ? entityDataLeft.label
                                      : ORGANIZATION_ENTITY.label
                                  }
                                  value={
                                    PERSON_TYPE_ENTITIES.find(
                                      (entity) =>
                                        entity.label === entityDataLeft.label
                                    )
                                      ? entityDataLeft.value
                                      : ORGANIZATION_ENTITY.value
                                  }
                                  setViewEntityRecord={(record) => {
                                    setViewEntityRecord(record)
                                    setRenderKey((prev) => !prev)
                                  }}
                                  viewEntityRecord={viewEntityRecord}
                                  currStep={currStep}
                                  setCurrStep={setCurrStep}
                                  editEntityRecord={editEntityRecord}
                                  setEditEntityRecord={(value) => {
                                    setEditEntityRecord(value)
                                  }}
                                  addEntityRecord={addEntityRecord}
                                  setAddEntityRecord={(value) => {
                                    setAddEntityRecord(value)
                                  }}
                                  setRequestorId={setRequestorId}
                                />
                              </div>
                            ) : null}

                            {selectedProductId && currStep === 0 && (
                              <div className={getClassName(viewEntityRecord)}>
                                <Accordion
                                  heading={
                                    CALL_INTERACTIONS.SEARCH_REQUESTOR_INFORMATION
                                  }
                                  isDefaultActive
                                >
                                  <RecordFields
                                    advancedFiltersData={advancedFiltersData}
                                    setAdvancedFiltersData={
                                      setAdvancedFiltersData
                                    }
                                    setBackToFirstPage={setBackToFirstPage}
                                    backToFirstPage={backToFirstPage}
                                    selectedProgramId={selectedProgramId}
                                    selectedProductId={selectedProductId}
                                    isLeftPanel={true}
                                    setViewEntityRecord={setViewEntityRecord}
                                    entityData={entityDataLeft}
                                    setEntityData={setEntityDataLeft}
                                    currStep={currStep}
                                    setCurrStep={setCurrStep}
                                    handleCreateWorkflowInstance={
                                      handleCreateWorkflowInstance
                                    }
                                    setRequestorId={setRequestorId}
                                    receivedDate={
                                      faxDetails?.created_at
                                        ? new Date(
                                            faxDetails.created_at
                                          ).toISOString()
                                        : ''
                                    }
                                    selectedRecord={selectedRecord}
                                    setSelectedRecord={setSelectedRecord}
                                    entityDataInner={entityDataInner}
                                    setEntityDataInner={setEntityDataInner}
                                    setRecordFieldsEntityDataPayload={
                                      setRecordFieldsEntityDataPayload
                                    }
                                    recordFieldsEntityDataPayload={
                                      recordFieldsEntityDataPayload
                                    }
                                    setRecordFieldsInfo={setRecordFieldsInfo}
                                    recordFieldsInfo={recordFieldsInfo}
                                    communicationKey={
                                      faxDetails?.communication_id?.toString() ??
                                      faxDetails?.enrollment_id?.toString() ??
                                      ''
                                    }
                                    setEditEntityRecord={setEditEntityRecord}
                                    setAddEntityRecord={setAddEntityRecord}
                                  />
                                </Accordion>
                              </div>
                            )}
                          </div>
                        ) : (
                          <div className="h-full">{content}</div>
                        )}
                      </div>
                    </div>
                  </div>
                </Panel>
              )}
            </div>
          </PanelGroup>
        </div>
      </FocusTrap>
    </CallInteractionContextProvider>
  )
}

export default IntakeQueReview

//call-interaction variables
const steps: StepType[] = [
  {
    label: NAMESPACES.SEARCH_REQUESTER_INFORMATION,
    status: NAMESPACES.COMPLETED_STEPPER,
    order: 1,
  },
  {
    label: NAMESPACES.REVIEW_REQUESTOR,
    status: NAMESPACES.IN_PROGERSS_STEPPER,
    order: 2,
  },
  {
    label: NAMESPACES.SELECT_AND_CREATE_CASE,
    status: NAMESPACES.PENDING_STEPPER,
    order: 3,
  },
]

const PERSON_TYPE_ENTITIES = [
  {
    label: 'Patient',
    value: '18',
  },
  {
    label: 'Provider',
    value: '4',
  },
  {
    label: 'Contact',
    value: '998',
  },
]

export const ORGANIZATION_ENTITY = {
  label: 'Organization',
  value: '997',
}

// const CASE_ENTITY = {
//   label: 'Case',
//   value: '32',
// }

// call-interaction components
const ViewEntitySection = (props: EntityDataProps | undefined) => {
  // const { tabs, setTabOffset } = useContext(CallInteractionContext)
  const dispatch = useAppDispatch()
  const requestorConfig = useAppSelector(
    (state: RootState) => state.requestor.payload
  )
  const [layout, setLayout] = useState<LayoutResponseType | undefined>()
  const [editLayout, setEditLayout] = useState<LayoutResponseType | undefined>()
  const allLayouts = useRef<LayoutResponseType[]>([])
  const [viewData, setViewData] = useState<FieldValues>()
  const [renderKey, setRenderKey] = useState<boolean>(false)
  const [isDuplicateModalOpen, setIsDuplicateModalOpen] =
    useState<boolean>(false)
  const [listingLayout, setListingLayout] = useState<LayoutResponseType>()
  const [selectedRow, setSelectedRow] = useState<ListingTableRow | null>(null)
  const [addedRecord, setAddedRecord] = useState<FieldValues | null>(null)
  const [viewDuplicateRecord, setViewDuplicateRecord] = useState<boolean>(false)
  const entitiesByName = useAppSelector(
    (state: RootState) => state.entity.entitiesByName
  )
  const [viewLayout, setViewLayout] = useState<LayoutResponseType>()
  const [viewRecordData, setViewRecordData] = useState<FieldValues>()
  const [refetchKey, setRefetchKey] = useState<number>(0)
  const [tabIndexMap, setTabIndexMap] = useState<TabIndexMap>({})
  const [totalRecords, setTotalRecords] = useState<number>(0)
  const extraColumn: ListingTableColumn[] = [
    {
      header: '',
      accessor: DUPLICATION.SELECT_ACCESSOR,
      type: DUPLICATION.RADIO_TYPE,
      onClick(_KeyName, row, _rowIndex) {
        setRefetchKey((prev) => prev + 1)
        setSelectedRow(row)
      },
    },
    {
      header: APPLICATION_PREFERENCES_STRINGS.MATCH_SCORE,
      accessor: DUPLICATION.SCORE_ACCESSOR,
      type: DUPLICATION.COMPONENT_TYPE,
      renderComponent: (row) => {
        return (
          <div className="flex items-center gap-1">
            <span>{String(row?.score ?? '')}</span>
            <DuplicationScore
              groups={row?.matchDetails as unknown as Group[]}
            />
          </div>
        )
      },
    },
  ]
  const extraActions: (TableActionType<DataTypeStore> & {
    onClick?: (row: ListingTableRow, rowIndex: number) => void
  })[] = [
    {
      label: NAMESPACES.VIEW,
      key: ACTION_ICONS_NAMESPACE.VIEW,
      onClick: async (row) => {
        const layoutId = await fetchViewLayout()
        setSelectedRow(row)
        setViewDuplicateRecord(true)
        setRefetchKey((prev) => prev + 1)
        fetchViewRecordData(layoutId, row?.id)
      },
    },
  ]

  const handleEditModalData = async (values: FieldValues) => {
    dispatch(showLoader())
    try {
      await editEntityData(
        props?.label ?? '',
        Number(props?.value),
        layout?.id ?? 0,
        values,
        ((props?.viewEntityRecord?.record_id ??
          props?.viewEntityRecord?.id) as number) ?? '',
        []
      )
      dispatch(
        addToaster({
          message: TOASTER_NAMESPACE.EDIT_SUCCESS,
          type: 'success',
          id: uuid(),
        })
      )
      fetchEntityData()
      setRenderKey((prev) => !prev)
    } catch (err) {
      dispatch(
        addToaster({
          message: TOASTER_NAMESPACE.FAILED_TO_EDIT_RECORD,
          type: 'error',
          id: uuid(),
        })
      )
    } finally {
      dispatch(hideLoader())
      props?.setViewEntityRecord?.(undefined)
      props?.setEditEntityRecord?.(false)
      props?.setAddEntityRecord?.(false)
      props?.setCurrStep && props?.setCurrStep((prev) => prev - 1)
    }
  }

  const fetchEntityData = async () => {
    dispatch(showLoader())
    try {
      const viewEntityData = await getEntityData(
        props?.label ?? '',
        Number(props?.value),
        layout?.id ?? 0,
        (props?.viewEntityRecord?.record_id as number) ??
          (props?.viewEntityRecord?.id as number) ??
          selectedRow?.record_id ??
          selectedRow?.id ??
          ''
      )
      setViewData(viewEntityData?.data)
      if (layout?.entity?.entity_name?.toLowerCase() === 'patients') {
        dispatch(updatePatientData(flattenObject(viewEntityData?.data)))
      }
    } catch (err) {
      console.log(err)
    } finally {
      dispatch(hideLoader())
    }
  }

  const triggerFormSubmit = () => {
    const adjacentDiv = document.getElementById('requestor-edit-form')
    const form =
      adjacentDiv?.nextElementSibling?.tagName === 'FORM'
        ? adjacentDiv.nextElementSibling
        : adjacentDiv?.nextElementSibling?.querySelector('form')
    if (form) {
      ;(form as HTMLFormElement).requestSubmit()
    }
  }

  const handleAddEntityData = async (values: FieldValues) => {
    dispatch(showLoader())
    try {
      await addEntityData(
        props?.label ?? '',
        Number(props?.value),
        layout?.id ?? 0,
        values,
        []
      )
      dispatch(
        addToaster({
          message: TOASTER_NAMESPACE.ADD_SUCCESS,
          type: 'success',
          id: uuid(),
        })
      )
    } catch (err) {
      dispatch(
        addToaster({
          message: TOASTER_NAMESPACE.FAILED_TO_ADD_RECORD,
          type: 'error',
          id: uuid(),
        })
      )
      console.error(err)
    } finally {
      // props?.setTriggerSearch?.(true)
      dispatch(hideLoader())
      props?.setCurrStep?.((prev) => prev - 1)
      props?.setViewEntityRecord?.(undefined)
      props?.setEditEntityRecord?.(false)
      props?.setAddEntityRecord?.(false)
    }
  }

  const handleFormSubmit = async (
    finalvalues: FieldValues,
    _embedded: string[],
    originalFormData: FieldValues | undefined
  ) => {
    const values = { ...finalvalues, ...originalFormData }
    dispatch(showLoader())
    try {
      const entity = entitiesByName[editLayout?.entity_name ?? '']
      if (!props?.editEntityRecord) {
        const flagValue = validatePhoneNumberAndAddress(values, dispatch)
        if (flagValue) {
          return
        }
      }
      if (props?.editEntityRecord) {
        handleEditModalData(values)
      } else if (entity?.is_duplicate) {
        const listingLayout = await fetchListingLayout()
        await fetchTableDataCallback(values, listingLayout?.id)
      } else {
        handleAddEntityData(values)
      }
    } catch (err) {
      console.error(err)
    } finally {
      dispatch(hideLoader())
    }
  }

  const fetchListingLayout = async () => {
    try {
      // let patientViewId = 0
      // let providerViewId = 0

      // entitiesList.forEach((entity: { name: string; id: number }) => {
      //   if (entity.name === ENTITY_NAME.PATIENT_VIEW_KEY) {
      //     patientViewId = entity.id ?? 0
      //   } else if (entity.name === ENTITY_NAME.PROVIDER_VIEW_KEY) {
      //     providerViewId = entity.id ?? 0
      //   }
      // })
      // let response
      // if (entityName === NAMESPACES.PATIENT_KEY) {
      //   response = await getAllLayoutApi({
      //     entityId: patientViewId?.toString() ?? '0',
      //     defaultValue: true,
      //     type: LAYOUT_TYPE_NAMESPACE.LAYOUT_LISTING,
      //   })
      //   setListingLayout(response?.data?.content?.[0])
      // } else if (entityName === NAMESPACES.PROVIDER_KEY) {
      //   response = await getAllLayoutApi({
      //     entityId: providerViewId?.toString() ?? '0',
      //     defaultValue: true,
      //     type: LAYOUT_TYPE_NAMESPACE.LAYOUT_LISTING,
      //   })
      //   setListingLayout(response?.data?.content?.[0])
      // } else {
      //   response = await getLayoutByName({
      //     entityId: element?.meta?.relationship?.parent_entity_id.toString(),
      //     layoutName: 'Requestor Search Layout',
      //   })
      //   setListingLayout(response?.data)
      // }
      const res = await getLayoutByEntityIdAndTypeApi({
        entityId: editLayout?.entity_id.toString() ?? '',
        type: LAYOUT_TYPE_NAMESPACE?.LAYOUT_LISTING,
        isDefault: true,
      })
      if (res?.data) {
        setListingLayout(res.data?.[0])
        return res.data?.[0]
      }
    } catch (err) {
      console.error(err)
    }
  }

  const fetchTableDataCallback = async (
    values: FieldValues,
    listingLayoutId: string | number,
    payload?: getEntityDataByEntityFilter['payload'] & { layout_id: number }
  ) => {
    if (listingLayoutId) {
      const duplicateApiPayload = transformToDuplicateApiPayload(
        values,
        editLayout?.entity_id?.toString() ?? '',
        listingLayoutId.toString(),
        editLayout
      )
      const res = await fetchDuplicateRecordsAPI(
        editLayout?.entity_id ?? 0,
        duplicateApiPayload,
        payload?.page as number,
        payload?.size as number
      )
      const addSelectedFlag = (data: ListingTableRow[]) => {
        return data.map((row) => ({
          ...row,
          select: row?.id === selectedRow?.id ? true : false,
        }))
      }
      res.data.content = addSelectedFlag(res?.data?.content)
      setTotalRecords(res?.data?.totalElements ?? 0)

      if (res?.data?.content.length != 0) {
        setAddedRecord(values)
        setIsDuplicateModalOpen(true)
      } else {
        createNewRecord(values)
      }

      return res?.data
    }
  }

  const requestorPayload = (row: DataTypeStore) => ({
    entity_name: 'requestor_view',
    select: ['name', 'record_id', 'record_key', 'entity_type'],
    page: 0,
    size: 1,
    filters: [
      {
        criteria: [
          {
            field_name: 'record_key',
            operation: 'LIKE',
            values: [
              (row?.['Patient ID'] ||
                row?.patient_key ||
                row?.['Provider ID'] ||
                row?.provider_key ||
                row?.['Facility ID'] ||
                row?.case_key ||
                row?.contact_key ||
                row?.organization_key ||
                '') as string,
            ],
          },
        ],
      },
    ],
  })

  const requestorPayloadAdd = (id: number | string, entityType: string) => ({
    entity_name: 'requestor_view',
    select: ['name', 'record_id', 'record_key', 'entity_type'],
    page: 0,
    size: 1,
    filters: [
      {
        criteria: [
          {
            field_name: 'record_id',
            operation: 'LIKE',
            values: [id as string],
          },
          {
            field_name: 'entity_type',
            operation: 'LIKE',
            values: [entityType],
          },
        ],
      },
    ],
  })

  const fetchAndSetRequestorData = async (
    row: DataTypeStore,
    id?: string | number,
    entityType?: string
  ) => {
    dispatch(showLoader())
    dispatch(updateRequestorConfigReducer({ row, id, entityType }))
    const response = await getEntityDataByEntityNameApiForFilter({
      payload:
        id && entityType
          ? requestorPayloadAdd(id, entityType)
          : requestorPayload(row),
    })
    const updatedResponse = reverseMappingOfRequestorName(response.data.content)
    if (!response?.data?.content?.length) {
      dispatch(
        addToaster({
          id: uniqueId(),
          message: REQUESTOR_MESSAGES.REQUESTOR_FAIL,
          type: 'error',
        })
      )
    } else {
      dispatch(
        addToaster({
          id: uniqueId(),
          message: REQUESTOR_MESSAGES.REQUESTOR_SUCCESS,
          type: 'success',
        })
      )
    }
    if (id)
      row = {
        id: id,
      }
    if (entityType)
      row = {
        ...row,
        entity_type: entityType,
      }
    props?.setViewEntityRecord?.({
      ...row,
      entity_type: updatedResponse?.[0]?.entity_type,
      requestor_id: updatedResponse?.[0]?.id,
    })
    if (props?.setRequestorId) {
      props.setRequestorId(updatedResponse?.[0]?.id)
    }
    dispatch(hideLoader())
  }

  const closeAndMoveToAdvancedSearch = (
    step: number,
    id?: string | number,
    entityType?: string
  ) => {
    dispatch(showLoader())
    setAddedRecord(null)
    setIsDuplicateModalOpen(false)
    setViewDuplicateRecord(false)
    props?.setCurrStep?.(step)
    if (step === 1) {
      if (!selectedRow && id) {
        dispatch(updateRequestorConfigReducer({ id, entityType }))
        setTimeout(() => {
          fetchAndSetRequestorData(
            selectedRow as unknown as DataTypeStore,
            id,
            entityType
          )
          dispatch(hideLoader())
        }, 4000)
      } else {
        dispatch(updateRequestorConfigReducer({ selectedRow }))
        fetchAndSetRequestorData(selectedRow as DataTypeStore, id, entityType)
        dispatch(hideLoader())
      }
    } else {
      dispatch(hideLoader())
    }

    props?.setEditEntityRecord?.(false)
    props?.setAddEntityRecord?.(false)
    props?.setBackToFirstPage?.(true)
    fetchEntityData()
  }

  const createNewRecord = async (values?: FieldValues) => {
    dispatch(showLoader())
    try {
      const res = await addEntityData(
        editLayout?.entity_name ?? '',
        Number(editLayout?.entity_id),
        Number(editLayout?.id),
        addedRecord ?? values ?? {}
      )
      if (res?.data) {
        dispatch(
          addToaster({
            id: uniqueId(),
            message: TOASTER_NAMESPACE?.ADD_SUCCESS,
            type: 'success',
          })
        )
        closeAndMoveToAdvancedSearch(
          1,
          res?.data?.id,
          editLayout?.entity_name ?? ''
        )
      }
    } catch (err) {
      console.error(err)
    } finally {
      dispatch(hideLoader())
    }
  }

  const fetchViewLayout = async () => {
    dispatch(showLoader())
    try {
      const res = await getLayoutByEntityIdAndTypeApi({
        entityId: String(editLayout?.entity_id),
        type: LAYOUT_TYPE_NAMESPACE?.OVERVIEW_TYPE,
        isDefault: true,
      })
      if (res?.data) {
        setViewLayout(res?.data?.[0])
        return res?.data?.[0]?.id
      }
    } catch (err) {
      console.error(err)
    } finally {
      dispatch(hideLoader())
    }
  }

  const fetchViewRecordData = async (layoutId: number, id: number) => {
    dispatch(showLoader())
    try {
      const res = await getEntityData(
        String(editLayout?.entity_name),
        Number(editLayout?.entity_id),
        layoutId,
        id
      )
      if (res?.data) {
        setViewRecordData(res?.data)
      }
    } catch (err) {
      console.error(err)
    } finally {
      dispatch(hideLoader())
    }
  }

  useEffect(() => {
    const fetchLayouts = async (): Promise<LayoutResponseType[]> => {
      try {
        dispatch(showLoader())
        const response = await getAllLayoutApi({
          entityId: props?.value?.toString(),
          defaultValue: true,
        })
        return response.data.content ?? []
      } catch (err) {
        console.error(err)
        return []
      } finally {
        dispatch(hideLoader())
      }
    }

    const updateLayouts = async () => {
      allLayouts.current = await fetchLayouts()
      allLayouts.current.forEach((layout) => {
        if (
          layout.type === LAYOUT_TYPE_NAMESPACE.OVERVIEW_TYPE &&
          layout.default_value
        ) {
          setLayout(layout)
        }
        if (
          layout.type === LAYOUT_TYPE_NAMESPACE.DEFAULT_VIEW_EDIT &&
          layout.default_value
        ) {
          setEditLayout(layout)
        }
      })
    }

    updateLayouts()
  }, [])

  useEffect(() => {
    if (layout) {
      fetchEntityData()
      const indexMap = generateTabIndexMap(
        layout?.layout_data?.pages as unknown as Page[]
      )
      // const maxIndexVaue = getMaxTabIndexValue({ indexMap })
      setTabIndexMap(indexMap)
      // setTabOffset &&
      //   setTabOffset(maxIndexVaue ? maxIndexVaue + ROWS_TAB_DIFFERENCE : 0)
    }
  }, [layout])

  return (
    <div className="border border-1 p-3">
      <div className="flex items-center justify-between pb-2">
        {!isDuplicateModalOpen ? (
          <div className="flex items-center gap-3 w-full">
            <div className={'cursor-pointer'}>
              <span
                className="font-medium text-base font-primary"
                onClick={() => {
                  props?.setCurrStep?.((prev) => prev - 1)
                  if (props?.currStep === 1) {
                    props?.setViewEntityRecord?.(undefined)
                    props?.setEditEntityRecord?.(false)
                    props?.setAddEntityRecord?.(false)
                    props?.setBackToFirstPage?.(true)
                  }
                }}
                onKeyDown={(e) => {
                  if (
                    e?.key === ShortcutKeys.Enter ||
                    e.key === ShortcutKeys.Space
                  ) {
                    props?.setCurrStep?.((prev) => prev - 1)
                    if (props?.currStep === 1) {
                      props?.setViewEntityRecord?.(undefined)
                      props?.setEditEntityRecord?.(false)
                      props?.setAddEntityRecord?.(false)
                      props?.setBackToFirstPage?.(true)
                    }
                  }
                }}
                tabIndex={0}
              >
                {APPLICATION_PREFERENCES_STRINGS.ADVANCED_SEARCH}
              </span>
            </div>
            <div>
              <span
                className={`font-medium text-base font-primary cursor-pointer ${
                  props?.viewEntityRecord || props?.addEntityRecord
                    ? 'text-primary-500'
                    : ''
                }`}
              >
                {`/ ${
                  props?.editEntityRecord
                    ? NAMESPACES.EDIT
                    : props?.addEntityRecord
                    ? NAMESPACES.ADD
                    : NAMESPACES.VIEW
                } ${props?.label}`}
              </span>
            </div>
            {props?.viewEntityRecord &&
              !props?.viewEntityRecord?.requestor_id && (
                <div
                  className="ml-auto cursor-pointer"
                  onClick={() =>
                    !isEmpty(requestorConfig?.id) &&
                    !isEmpty(requestorConfig?.entityType)
                      ? fetchAndSetRequestorData(
                          requestorConfig?.row ?? {},
                          requestorConfig?.id ?? '',
                          requestorConfig?.entityType ?? ''
                        )
                      : fetchAndSetRequestorData(requestorConfig?.row ?? {})
                  }
                >
                  <SvgReload />
                </div>
              )}
          </div>
        ) : (
          <div>
            <span
              className="font-medium text-base font-primary cursor-pointer"
              onClick={() => {
                props?.setCurrStep?.((prev) => prev - 1)
                if (props?.currStep === 1) {
                  props?.setViewEntityRecord?.(undefined)
                  props?.setEditEntityRecord?.(false)
                  props?.setAddEntityRecord?.(false)
                  props?.setBackToFirstPage?.(true)
                }
              }}
              onKeyDown={(e) => {
                if (
                  e?.key === ShortcutKeys.Enter ||
                  e.key === ShortcutKeys.Space
                ) {
                  props?.setCurrStep?.((prev) => prev - 1)
                  if (props?.currStep === 1) {
                    props?.setViewEntityRecord?.(undefined)
                    props?.setEditEntityRecord?.(false)
                    props?.setAddEntityRecord?.(false)
                    props?.setBackToFirstPage?.(true)
                  }
                }
              }}
              tabIndex={0}
            >
              {APPLICATION_PREFERENCES_STRINGS?.ADVANCED_SEARCH}{' '}
            </span>
            <span
              className={`font-medium text-base font-primary cursor-pointer`}
              onClick={() => {
                setViewDuplicateRecord(false)
                setIsDuplicateModalOpen(false)
                setSelectedRow(null)
                props?.setEditEntityRecord?.(false)
                props?.setCurrStep?.(1)
              }}
            >
              {`/ ${NAMESPACES.ADD} ${props?.label} / `}
            </span>
            <span
              className={`font-medium text-base font-primary cursor-pointer ${
                !viewDuplicateRecord ? `text-primary-500` : ``
              }`}
              onClick={() => {
                setViewDuplicateRecord(false)
              }}
            >
              {APPLICATION_PREFERENCES_STRINGS?.DUPLICATE_HEADING}
            </span>
            {viewDuplicateRecord && (
              <span className="font-medium text-base font-primary cursor-pointer text-primary-500">
                {` / ${NAMESPACES.VIEW} ${props?.label}`}
              </span>
            )}
          </div>
        )}
        {props?.editEntityRecord ? (
          <div className="flex gap-3">
            <CustomButton
              className="!h-[1.75rem]"
              onClick={() => {
                props?.setViewEntityRecord?.(undefined)
                props?.setEditEntityRecord?.(false)
                props?.setAddEntityRecord?.(false)
                props?.setCurrStep?.((prev) => prev - 1)
              }}
            >
              {BUTTONS.CANCEL}
            </CustomButton>
            <CustomButton
              isFilled={true}
              className="!h-[1.75rem]"
              type="submit"
              onClick={() => {
                triggerFormSubmit()
              }}
            >
              {BUTTONS.UPDATE}
            </CustomButton>
          </div>
        ) : props?.addEntityRecord ? (
          isDuplicateModalOpen ? (
            <div className="flex gap-2">
              <CustomButton
                isFilled
                onClick={() => {
                  setSelectedRow(null)
                  createNewRecord()
                }}
              >
                {APPLICATION_PREFERENCES_STRINGS?.CREATE_ANYWAY}
              </CustomButton>
              <CustomButton
                isFilled
                onClick={() => {
                  closeAndMoveToAdvancedSearch(1)
                }}
                disabled={isEmpty(selectedRow)}
              >
                {APPLICATION_PREFERENCES_STRINGS?.USE_EXISTING}
              </CustomButton>
            </div>
          ) : (
            <div>
              <CustomButton
                isFilled
                type="submit"
                className="!h-[1.75rem]"
                onClick={() => {
                  triggerFormSubmit()
                }}
              >
                {BUTTONS.SAVE}
              </CustomButton>
            </div>
          )
        ) : null}
      </div>
      {(props?.editEntityRecord ||
        props?.addEntityRecord ||
        props?.viewEntityRecord) &&
      !isDuplicateModalOpen ? (
        <FormRenderer
          layout={
            (props?.editEntityRecord || props?.addEntityRecord
              ? editLayout?.layout_data
              : layout?.layout_data) as LayoutData
          }
          mode={
            props?.editEntityRecord
              ? MODE_CONSTANTS.EDIT
              : props?.addEntityRecord
              ? MODE_CONSTANTS.ADD
              : MODE_CONSTANTS.VIEW
          }
          fullLayout={
            (props?.editEntityRecord || props?.addEntityRecord
              ? editLayout
              : layout) as EntityLayout
          }
          heading={null}
          handleFormSubmit={handleFormSubmit}
          data={props?.addEntityRecord ? addedRecord : viewData}
          key={renderKey.toString()}
          tabIndexMap={tabIndexMap}
          formUniqueId="requestor-edit-form"
        />
      ) : null}

      {isDuplicateModalOpen &&
        (!viewDuplicateRecord ? (
          <>
            <span className="font-light text-xs pb-2">
              {totalRecords}{' '}
              {totalRecords > 1
                ? `${APPLICATION_PREFERENCES_STRINGS.RECORD}s`
                : APPLICATION_PREFERENCES_STRINGS.RECORD}
              {` ${APPLICATION_PREFERENCES_STRINGS.FOUND}`}
            </span>
            <ListingTable
              entityId={Number(editLayout?.entity_id)}
              entityName={editLayout?.entity_name ?? ''}
              extraActions={extraActions}
              layout={listingLayout}
              dataFetchCallback={(payload) =>
                fetchTableDataCallback(
                  addedRecord ?? {},
                  listingLayout?.id ?? 0,
                  payload
                )
              }
              extraColumns={extraColumn}
              hideFilters={true}
              refetchKey={refetchKey}
              openInNewTab={true}
            />
          </>
        ) : (
          <FormRenderer
            heading={null}
            layout={viewLayout?.layout_data as LayoutData}
            mode={MODE_CONSTANTS?.VIEW}
            handleFormSubmit={noop}
            fullLayout={viewLayout as EntityLayout}
            data={viewRecordData}
          />
        ))}
      {/* TODO: Remove 
      {openAddModal && editLayout && (
        <Modal
          isOpen={openAddModal}
          closeModal={toggleAddModal}
          showCloseButton={false}
          width="w-[75vw]"
        >
          {isLoading ? (
            <Loader isGlobal={false} loaderHeight="40" loaderWidth="40" />
          ) : null}

          <div className={`flex flex-col gap-2 ${isLoading ? 'hidden' : ''}`}>
            <FormRenderer
              heading={
                <div className="flex items-center justify-between gap-4 pb-2">
                  <div className="flex items-center gap-3">
                    <div className="cursor-pointer">
                      <SvgLeftArrow
                        onClick={toggleAddModal}
                        className="svg-path-fill-accent-900"
                      />
                    </div>
                    <span className="font-medium text-base/6 font-primary">
                      {`Edit ${props?.label}`}
                    </span>
                  </div>

                  <div className="flex items-center gap-3">
                    <div className="flex gap-3">
                      <CustomButton onClick={toggleAddModal}>
                        <span>{BUTTONS.CANCEL}</span>
                      </CustomButton>
                      <CustomButton isFilled type="submit">
                        <span>{BUTTONS.UPDATE}</span>
                      </CustomButton>
                    </div>
                  </div>
                </div>
              }
              layout={editLayout?.layout_data as LayoutData}
              fullLayout={editLayout as EntityLayout}
              mode={MODE_CONSTANTS?.EDIT}
              handleFormSubmit={handleEditModalData}
              data={viewData}
            />
          </div>
        </Modal>
      )} */}
    </div>
  )
}

const RecordFields = ({
  selectedProgramId,
  selectedProductId,
  isLeftPanel,
  setViewEntityRecord,
  setEntityData,
  handleCreateWorkflowInstance,
  tabIndex,
  setCurrStep,
  setRequestorId,
  receivedDate,
  selectedRecord,
  setSelectedRecord,
  entityDataInner,
  setEntityDataInner,
  recordFieldsEntityDataPayload,
  setRecordFieldsEntityDataPayload,
  recordFieldsInfo,
  setRecordFieldsInfo,
  backToFirstPage,
  setBackToFirstPage,
  advancedFiltersData,
  setAdvancedFiltersData,
  communicationKey,
  setEditEntityRecord,
  setAddEntityRecord,
}: RecordFieldsProps) => {
  const { viewEntityRecord } = useContext(CallInteractionContext)
  const [renderKey, setRenderKey] = useState<boolean>(false)
  const [entityOptions, setEntityOptions] = useState<DropdownType<string>[]>([])
  const entityDataInnerRef = useRef<EntityDataProps | undefined>(undefined)

  const dispatch = useAppDispatch()

  const handleRecordTypeChange = async (
    e: DropdownType<unknown, string> | undefined,
    defaultRecordType?: string
  ) => {
    setSelectedRecord && setSelectedRecord(defaultRecordType ?? e?.value)
    if ((defaultRecordType ?? e?.value) === 'person') {
      setEntityOptions(PERSON_TYPE_ENTITIES)
      setEntityData?.(undefined)
      setEntityDataInner && setEntityDataInner(undefined)
    } else if ((defaultRecordType ?? e?.value) === 'organization') {
      dispatch(showLoader())
      try {
        const response = await getEntityList({
          entity_name: 'organization_type',
          embedded_name: 'name',
        })
        if (response.data) {
          setEntityOptions(
            response?.data?.content?.map(
              (item: { id: number; name: string }) => ({
                label: item.name,
                value: item.id.toString(),
              })
            )
          )
        }
      } catch (err) {
        console.log(err)
      } finally {
        dispatch(hideLoader())
      }
      setEntityData?.(undefined)
      setEntityDataInner && setEntityDataInner(undefined)
    } else {
      setEntityOptions([])
      setEntityData?.({
        label: '',
        value: '',
      })
      setEntityDataInner &&
        setEntityDataInner({
          label: '',
          value: '',
        })
    }
    setRenderKey((prev) => !prev)
  }
  const handleEntityChange = (e: DropdownType<unknown, string>) => {
    setRecordFieldsEntityDataPayload?.(undefined)
    setAdvancedFiltersData?.(undefined)
    setEntityData?.({
      label: e.label,
      value: e.value,
    })
    setEntityDataInner &&
      setEntityDataInner({
        label: e.label,
        value: e.value,
      })
    setRenderKey((prev) => !prev)
  }
  const getDataQaId = (isLeftPanel: boolean | undefined) =>
    isLeftPanel ? 'left' : 'right'
  const checkIfDisabled = (
    isLeftPanel: boolean | undefined,
    viewEntityRecord: DataTypeStore | undefined
  ) => !isLeftPanel && !viewEntityRecord

  useEffect(() => {
    if (entityDataInnerRef?.current && entityOptions?.length) {
      setEntityData?.(entityDataInnerRef?.current)
      setEntityDataInner?.(entityDataInnerRef?.current)
    }
  }, [entityOptions])

  useEffect(() => {
    if (entityDataInner) {
      entityDataInnerRef.current = entityDataInner
    }
  }, [])
  useEffect(() => {
    if (!entityDataInner) {
      entityDataInnerRef.current = undefined
    }
  }, [entityDataInner])
  useEffect(() => {
    if (selectedRecord) {
      handleRecordTypeChange(undefined, selectedRecord)
    }
  }, [selectedRecord])

  return (
    <div>
      <div className="grid grid-cols-3 gap-x-3 py-5 px-3">
        {!isLeftPanel ? (
          <SelectDropDown
            label="Entity Type"
            options={[
              {
                label: 'Person',
                value: 'person',
              },
              {
                label: 'Organization',
                value: 'organization',
              },
              {
                label: 'Case',
                value: 'case',
              },
            ]}
            name=""
            onChange={(e) =>
              handleRecordTypeChange(e as DropdownType<unknown, string>)
            }
            required
            dataQaId={`requestor-record-type-${getDataQaId(isLeftPanel)}`}
            defaultValue={selectedRecord}
            disabled={checkIfDisabled(isLeftPanel, viewEntityRecord)}
            tabIndex={tabIndex ?? 0}
          />
        ) : null}
        <SelectDropDown
          label={'Entity'}
          options={isLeftPanel ? PERSON_TYPE_ENTITIES : entityOptions}
          onChange={handleEntityChange}
          name=""
          required
          dataQaId={`requestor-entity-${isLeftPanel ? 'left' : 'right'}`}
          isSearchable
          defaultValue={entityDataInner?.value ?? ''}
          disabled={checkIfDisabled(isLeftPanel, viewEntityRecord)}
          tabIndex={tabIndex ?? 0}
        />
      </div>
      {entityDataInner && (isLeftPanel || selectedRecord) ? (
        <div className="pb-5 px-3" key={renderKey.toString()}>
          <SearchLayout
            entity_id={
              selectedRecord === 'organization'
                ? ORGANIZATION_ENTITY.value
                : entityDataInner.value
            }
            entity_name={
              selectedRecord === 'organization'
                ? ORGANIZATION_ENTITY.label
                : entityDataInner.label
            }
            organizationType={
              selectedRecord === 'organization' ? entityDataInner : undefined
            }
            backToFirstPage={backToFirstPage}
            setBackToFirstPage={setBackToFirstPage}
            selectedProgramId={selectedProgramId}
            selectedProductId={selectedProductId}
            isLeftPanel={isLeftPanel}
            setViewEntityRecord={setViewEntityRecord}
            viewEntityRecord={viewEntityRecord}
            handleCreateWorkflowInstance={handleCreateWorkflowInstance}
            tabIndex={tabIndex}
            currStep={2}
            setCurrStep={setCurrStep}
            setRequestorId={setRequestorId}
            receivedDate={receivedDate}
            setRecordFieldsEntityDataPayload={setRecordFieldsEntityDataPayload}
            recordFieldsEntityDataPayload={recordFieldsEntityDataPayload}
            setRecordFieldsInfo={setRecordFieldsInfo}
            recordFieldsInfo={recordFieldsInfo}
            advancedFiltersData={advancedFiltersData}
            setAdvancedFiltersData={setAdvancedFiltersData}
            communicationKey={communicationKey}
            setEditEntityRecord={setEditEntityRecord}
            setAddEntityRecord={setAddEntityRecord}
          />
        </div>
      ) : null}
    </div>
  )
}
